import * as Yup from 'yup';

const campaignAllSegments = Yup.boolean();

export default campaignAllSegments;
